import { ConnectionResource } from 'api'
import add_menu_icon from 'assets/icons/add-connection-icon.svg'
import ellipse_2_green from 'assets/icons/ellipse-2-green.svg'
import ellipse_grey from 'assets/icons/ellipse-2-grey.svg'
import re_sync_connection_icon from 'assets/icons/re-sync-connection-icon.svg'
import { TableColumn } from 'components/Table/Table'

import * as Styled from '../styles'

type ConnectionStatus = 'NOT_INTEGRATED' | 'SUCCESS'

export const getConnectionColumns = (
  connectToGoogleBusinessProfile: () => void,
  openGoogleBusinessProfile: (marketingChannelId: string) => void,
  marketingChannelId: string,
  status?: ConnectionStatus,
  disableConnectBtn?: boolean,
): Array<TableColumn<ConnectionResource>> => [
  {
    dataIndex: 'platform',
    key: 'platform',
    title: 'Platform',
    render: (row) => (
      <>
        {status === 'SUCCESS' ? (
          <Styled.ConnectionLink onClick={() => openGoogleBusinessProfile(marketingChannelId)}>
            {row.attributes.title}
          </Styled.ConnectionLink>
        ) : (
          <Styled.MenuContainer>{row.attributes.title}</Styled.MenuContainer>
        )}
      </>
    ),
  },
  {
    dataIndex: 'status',
    key: 'status',
    title: 'Status',
    render: () => (
      <>
        <Styled.StatusContainer>
          <Styled.Icon src={status === 'SUCCESS' ? ellipse_2_green : ellipse_grey} />
          <Styled.ConnectionStatusText isSuccess={status === 'SUCCESS'}>
            {status === 'SUCCESS' ? 'Enabled' : 'Not Integrated'}
          </Styled.ConnectionStatusText>
        </Styled.StatusContainer>
      </>
    ),
  },
  {
    dataIndex: 'connect',
    key: 'connect',
    title: '',
    headerAlign: 'center',
    render: () => (
      <Styled.Icon
        hoverEffect={true}
        src={status === 'SUCCESS' ? re_sync_connection_icon : add_menu_icon}
        alt='connect menu icon'
        iconSize={'24'}
        onClick={connectToGoogleBusinessProfile}
        disabled={disableConnectBtn}
      />
    ),
  },
]
